<ion-item color="medium" mode="ios" (click)="select()"
          [ngStyle]="{'margin-bottom': (appKey !== 'clinic-portal') ? '24px' : '10px'}">
    <ion-label color="primary placeholder" *ngIf="!countryCode">{{placeholder}}</ion-label>
    <ion-label color="primary" *ngIf="countryCode">{{countryCode | country:localeShort}}</ion-label>
</ion-item>
